<template>
	<div class="menu">
		<v-btn class="menu-btn" flat dark v-on:click="is_drop = !is_drop;"><v-icon>menu</v-icon></v-btn>
		<transition>	
			<div class="menu-list-group" v-if="is_drop">
				<v-sheet color="#ECEFF1">
					<v-layout row wrap align-center pa-2 ma-0 class="menu-list-header">
						<v-flex xs2>
							<v-icon>account_circle</v-icon>
						</v-flex>
						<v-flex xs8 class="menu-list-title">
							{{loginMemberName}}
						</v-flex>
						<v-flex xs2>
							<v-btn depressed fab small flat
								@click="onClickShowEditMemberSelf"
							>
								<v-icon>more_vert</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
				</v-sheet>
				<v-layout v-if="availableToggleTick" hidden-md-and-up>
					<v-btn-toggle v-model="data_toggleTick" mandatory class="menu-list-item" style="height: 30px; width:100%">
						<v-btn v-for="term in terms" :key="term.id" :value="term.id"
							flat
							block
							class="primary--text"
						>
							{{term.text}}
						</v-btn>
					</v-btn-toggle>
				</v-layout>
				<v-btn flat block large class="menu-list-item ma-0" v-if="availableEditPinned" v-on:click="onClickShowEditProjectPinned" :disabled="!this.$store.getters.isEditable">
					案件の表示項目変更
				</v-btn>
				<v-btn flat block large class="menu-list-item ma-0" v-if="availableMember" v-on:click="onTransitionMember">
					進捗入力画面
				</v-btn>
				<v-btn flat block large class="menu-list-item ma-0" v-if="availableGanttChart" v-on:click="onTransitionGanttChart">
					ガントチャート
				</v-btn>
				<v-btn flat block large class="menu-list-item ma-0" v-on:click="onClickLogout">
					ログアウト
				</v-btn>
			</div>
		</transition>
	</div>
</template>

<script>
import router from '../router'
import {PERMISSION} from '../data/Const';
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';

export default {
	name: 'Menu',
	props: [
		"terms",
		"toggleTick",
	],
	data(){
		const state_default = new MouseState({
				down: (e) => {
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					if(obj.target.closest('.menu')){
						return ;
					}
					this.closeMenu();
				},
			});
		return {
			data_toggleTick: this.toggleTick,
			is_drop: false,
			menu_close: new MouseStateMachine(state_default),
		}
	},
	methods: {
		onTransitionMember: function() {
			router.push({
				name: 'MemberSchedule', 
				params: { 
					'contractor_id': this.$route.params.contractor_id,
					'id': this.$store.getters.accessToken.sub,
				},
			});
		},
		
		onTransitionGanttChart: function() {
			this.$store.dispatch('setSaveDisplayLeftDay', null);
			router.push({
				name: 'GanttBoard', 
				params: { 'contractor_id': this.$route.params.contractor_id },
			});
		},
		onClickLogout: function() {
			this.$store.dispatch('logout').then(() => {
				router.push({
					name: 'Login', 
					params: { 'contractor_id': this.$route.params.contractor_id },
				});
			});
		},
		closeMenu: function() {
			this.is_drop = false;
		},
		onClickShowEditMemberSelf: function() {
			this.$emit('show-edit-member-self');
		},
		onClickShowEditProjectPinned: function() {
			this.$emit('show-edit-project-pinned', 'default');
		},
	},
	computed: {
		availableMember: function() {
			let token = this.$store.getters.accessToken;
			return token && (token.pms & PERMISSION.TYPE.WORKER) && this.isShowGanttChart;
		},
		availableGanttChart: function() {
			let token = this.$store.getters.accessToken;
			return token && token.pms && !this.isShowGanttChart;
		},
		availableToggleTick: function() {
			let token = this.$store.getters.accessToken;
			return token && this.isShowGanttChart;
		},
		availableEditPinned: function() {
			return this.hasAdmin && this.isShowGanttChart;
		},
		loginMemberName: function() {
			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return;

			let member = this.$store.getters.mstMemberData(access_token.sub);
			if(member === undefined)
				return;

			return member.name;
		},
		isShowGanttChart: function() {
			return Boolean(!this.$route.params.id);
		},
		hasAdmin: function() {
			let access_token = this.$store.getters.accessToken;
			if (!access_token)
				return false;
			
			return (access_token.pms & PERMISSION.TYPE.ADMIN) > 0;
		},
	},
	mounted: function() {
		this.menu_close.bind(window);
	},
	beforeDestroy: function() {
		this.menu_close.unbind();
	},
	watch: {
		toggleTick: function(val) {
			this.data_toggleTick = val;
		},
		data_toggleTick: function(val) {
			this.closeMenu();
			this.$emit('change-calendar-tick', {value: val});
		},
	},
}
</script>
<style>
	.menu {
		position: relative;
		height: 30px;
	}
	.menu-btn {
		height: 30px !important;
		margin: 0px;
	}
	.menu-list-group {
		position: absolute;
		top:30px;
		right: 0px;
		width: 300px;
		background-color: white;
		border:solid 1px #DFDFDF;
		border-bottom: none;
		z-index: 104;
	}
	.menu-list-header {
		min-height: 50px;
		font-size: 100%;
		font-weight: bolder;
		border-bottom:solid 2px #DFDFDF;
	}
	.menu-list-title {
		word-wrap: break-word;
	}
	.menu-list-item {
		display: flex;
		justify-content: center;
		height: 50px !important;
		border-bottom:solid 1px #DFDFDF;
	}
</style>
<style scoped>
	.v-enter-active, .v-leave-active {
		transition: all 0.3s;
	}
	.v-enter {
		transform: translateY(-10px);
	}
	.v-enter, .v-leave-to {
		opacity: 0;
	}
</style>

